"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _homeReport = require("@/http/interface/sfe/homeReport");
var _configuaration = _interopRequireDefault(require("@/http/interface/base/configuaration"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
var _home = _interopRequireDefault(require("./components/home.vue"));
var _comment = _interopRequireDefault(require("@/views/dashboard/components/comment.vue"));
var _AssignTasks = _interopRequireDefault(require("@/components/AssignTasks"));
var _storage = require("@/utils/storage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  name: 'SrDetails',
  components: {
    Home: _home.default,
    Commment: _comment.default,
    AssignTasks: _AssignTasks.default
  },
  data: function data() {
    return {
      planTaskTypeList: [],
      srEmpNo: '',
      month: curDateTree.month,
      activeType: '1',
      visitFlag: true,
      currPage: 1,
      limit: 10,
      totalCount: 0,
      visitDetails: {},
      currentVisitList: [],
      listLoading: false,
      showCommentDialog: false,
      currentRow: {}
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    findTextByCode: function findTextByCode() {
      return function (code) {
        var target = this.planTaskTypeList.find(function (t) {
          return t.code === code;
        });
        if (target) {
          return target.name;
        } else {
          return '';
        }
      };
    }
  }),
  watch: {
    '$route.query.srEmpNo': {
      deep: true,
      handler: function handler(val) {
        if (val && val !== this.srEmpNo) {
          this.srEmpNo = val;
          this.fetchSrInfo();
          this.fetchVisitList(true);
        }
      }
    },
    month: function month(val, oldVal) {
      if (val !== oldVal) {
        this.fetchSrInfo();
        this.currPage = 1;
        this.fetchVisitList(true);
      }
    },
    language: function language(val, oldVal) {
      if (val !== oldVal) {
        this.fetchTypeList();
      }
    }
  },
  created: function created() {
    this.srEmpNo = this.$route.query.srEmpNo;
  },
  mounted: function mounted() {
    var _this = this;
    this.fetchSrInfo();
    this.listLoading = true;
    _configuaration.default.getConfigByCode({
      configItemCodeList: ['PLAN_TASK_TYPE']
    }).then(function (res) {
      _this.planTaskTypeList = res.data.PLAN_TASK_TYPE || [];
      _this.fetchVisitList(false);
    }).catch(function () {
      _this.listLoading = false;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'performanceReport' && _storage.SessionStorage.isItemExist('activeName')) {
      _storage.SessionStorage.removeItem('activeName');
      _storage.SessionStorage.removeItem('searchData');
    }
    next();
  },
  methods: {
    fetchTypeList: function fetchTypeList() {
      var _this2 = this;
      this.listLoading = true;
      _configuaration.default.getConfigByCode({
        configItemCodeList: ['PLAN_TASK_TYPE']
      }).then(function (res) {
        _this2.listLoading = false;
        _this2.planTaskTypeList = res.data.PLAN_TASK_TYPE || [];
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    typeChange: function typeChange(type) {
      this.visitFlag = type;
      this.currPage = 1;
      this.fetchVisitList(true);
    },
    fetchSrInfo: function fetchSrInfo() {
      var _this3 = this;
      var params = {
        month: this.month,
        empNo: this.srEmpNo,
        visitFlag: true
      };
      (0, _homeReport.getSRPersonInfo)(params).then(function (res) {
        _this3.visitDetails = res.data || {};
      });
    },
    fetchVisitList: function fetchVisitList(listLoading) {
      var _this4 = this;
      var params = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          month: this.month,
          empNo: this.srEmpNo,
          visitFlag: this.visitFlag
        }
      };
      this.listLoading = listLoading;
      (0, _homeReport.getSRVisitCustomerList)(params).then(function (res) {
        _this4.listLoading = false;
        _this4.currentVisitList = res.data.items || [];
        _this4.totalCount = res.data.totalCount;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    toVisitDetail: function toVisitDetail(row) {
      this.$router.push({
        path: '/planModule/storeVisitReport',
        query: {
          planTaskInfoPk: row.planTaskInfoPk,
          mode: 'view'
        }
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    comment: function comment(row, apiKey, rowKey) {
      var _this5 = this;
      console.log(row, apiKey, rowKey);
      var params = (0, _defineProperty2.default)({}, apiKey, row[rowKey] || "");
      (0, _homeReport.getCommentOrgBiz)(params).then(function (res) {
        _this5.currentRow = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          orgBiz: res.data || [],
          params: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
            dateType: "0",
            dateValue: "0"
          })
        });
      });
      this.showCommentDialog = true;
    },
    submitCommentDialog: function submitCommentDialog(form) {
      this.submitCommentByRow(form);
    },
    submitCommentByRow: function submitCommentByRow(form) {
      var _this6 = this;
      var empNoList = [].concat((0, _toConsumableArray2.default)(form.asm), (0, _toConsumableArray2.default)(form.sr));
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        empNoList: empNoList
      });
      (0, _homeReport.getCommentSendSingle)(params).then(function (res) {
        _this6.$message.success(_this6.$t("dashboard.commentSuccess"));
        _this6.closeCommentDialog();
      });
    },
    closeCommentDialog: function closeCommentDialog() {
      this.showCommentDialog = false;
      this.currentRow = {};
    },
    assignTasks: function assignTasks(SRInfo) {
      var param = {
        srEmpName: SRInfo.username,
        srEmpNo: SRInfo.empNo
      };
      this.$refs.AssignTasks.showModel(param, 'srDetail');
    }
  }
};